export enum Actions {
  SET_MENU = '@MENU/SET_MENU',
  RESET_MENU = '@MENU/RESET_MENU'
}
